<template>
  <div class="flex flex-col w-full h-full">
    <div class="flex flex-col h-full bg-white">
      <div class="data-container">
        <div class="data-container-header justify-between">
          <div class="flex">
            <h4>Tulu mallid</h4>
            <button
              @click="
                $store.commit(
                  `modals/taskModal/setNewRevenueTemplateModal`,
                  true
                )
              "
              class="btn-primary ml-3"
            >
              Lisa mall
            </button>
          </div>
        </div>
        <div class="data-container-content data-container-table">
          <div class="gwd-table nested">
            <div class="gwd-table-header task-revenue-table">
              <span>Tüüp</span>
              <span>Nimetus</span>
              <span>Tulu</span>
              <span>Ühik</span>
              <span>Käibemaks</span>
              <span>Tulukood</span>
            </div>
            <div
              v-for="(item, index) in revenueTemplates"
              :key="`prjtmp-${index}`"
              class="gwd-table-row task-revenue-table"
              :class="templatesToDelete.includes(item) ? 'item-to-delete' : ''"
            >
              <div class="flex">
                <select
                  v-model="item.type"
                  v-if="!templatesToDelete.includes(item)"
                >
                  <option
                    v-for="type in templateTypes"
                    :key="type.type"
                    :value="type.type"
                  >
                    {{ type.description }}
                  </option>
                </select>
                <span v-else>
                  {{
                    templateTypes.find((x) => x.type === item.type).description
                  }}
                </span>
              </div>
              <div class="flex">
                <input
                  v-model="item.description"
                  type="text"
                  class="pr-2"
                  v-if="!templatesToDelete.includes(item)"
                />
                <span v-else>
                  {{ item.description }}
                </span>
              </div>
              <div class="flex">
                <decimal-input
                  v-if="!templatesToDelete.includes(item)"
                  v-model="item.price"
                  class="pr-2"
                />
                <span v-else>
                  {{ item.price }}
                </span>
              </div>
              <div class="flex">
                <select
                  v-model="item.unit"
                  v-if="!templatesToDelete.includes(item)"
                >
                  <option v-for="unit in units" :key="unit" :value="unit">
                    {{ unit }}
                  </option>
                </select>
                <span v-else>
                  {{ item.unit }}
                </span>
              </div>
              <div class="flex">
                <gwd-tax-selector
                  v-model="item.vatType"
                  :allow-outgoing="true"
                  :allow-empty="true"
                  :read-only="templatesToDelete.includes(item)"
                />
              </div>
              <div class="flex pr-2">
                <select
                  v-if="!templatesToDelete.includes(item)"
                  v-model="item.serviceCode"
                >
                  <option :value="null" :key="null">Puudub</option>
                  <option
                    v-for="serviceObj in serviceObjects"
                    :key="serviceObj.id"
                    :value="serviceObj"
                    :disabled="serviceObj.service_code.length === 2"
                  >
                    {{
                      `${serviceObj.service_code} - ${serviceObj.service_name}`
                    }}
                  </option>
                </select>
                <span v-else>{{
                  item.serviceCode
                    ? `${item.serviceCode.service_code} - ${item.serviceCode.service_name}`
                    : "-"
                }}</span>
              </div>
              <div class="flex justify-end">
                <button
                  class="icon-button"
                  @click="toggleDeleteExistingTemplate(item)"
                  :class="
                    !templatesToDelete.includes(item) ? 'danger' : 'primary'
                  "
                >
                  <span
                    class="typcn typcn-trash text-xl filter-to-white"
                    v-if="!templatesToDelete.includes(item)"
                  />
                  <span
                    class="typcn typcn-arrow-back"
                    v-if="templatesToDelete.includes(item)"
                  ></span>
                </button>
              </div>
            </div>
            <div
              v-if="revenueTemplates.length === 0"
              class="p-2 flex rounded-b"
            >
              <span>Mallid puuduvad</span>
            </div>
          </div>
        </div>
        <div v-if="hasChanges" class="data-container-footer">
          <button @click="updateRevenueTemplates" class="btn-primary mr-3">
            <span class="typcn typcn-tick icon"></span>
            <span class="label">Salvesta</span>
          </button>
          <button @click="reset" class="btn-danger">
            <span class="typcn typcn-arrow-back icon"></span>
            <span class="label">Tühista</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import set from "lodash/set";
import { mapGetters } from "vuex";
import DecimalInput from "@/components/reusable/DecimalInput.vue";
import EventBus from "@/assets/mixins/EventBus";
import { isEqual } from "lodash";

export default {
  name: "TaskRevenueTemplates",
  components: { DecimalInput },
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      addCostTemplate: false,
      revenueTemplates: [],
      revenueTemplatesCopy: [],
      templatesToDelete: [],
    };
  },
  async mounted() {
    if (!this.taxTypes)
      await this.$store.dispatch("companyVariables/retrieveTaxTypes");
    if (!this.serviceObjects)
      await this.$store.dispatch("companyVariables/retrieveServiceObjects");
    this.listTaskRevenueTemplates();
    EventBus.$on("revenueTemplateSaved", this.listTaskRevenueTemplates);
  },
  beforeDestroy() {
    EventBus.$off("revenueTemplateSaved", this.listTaskRevenueTemplates);
  },
  methods: {
    toggleDeleteExistingTemplate(e) {
      if (this.templatesToDelete.includes(e)) {
        this.templatesToDelete.splice(
          this.templatesToDelete.indexOf(
            this.templatesToDelete.find((x) => x.id === e.id)
          ),
          1
        );
      } else {
        this.templatesToDelete.push(e);
      }
    },
    listTaskRevenueTemplates() {
      this.templatesToDelete = [];
      this.apiRequest(
        `template/${this.companyId}/costs/templates/?object_id=${this.taskId}&type=task`,
        "get",
        true
      ).then((res) => {
        this.revenueTemplates = res.data;
        for (let template of this.revenueTemplates) {
          set(
            template,
            "vatType",
            this.taxTypes.find((x) => x.id === template.vat) ?? null
          );
          set(
            template,
            "serviceCode",
            this.serviceObjects.find((x) => x.id === template.service_code) ??
              null
          );
        }
        this.revenueTemplatesCopy = JSON.parse(
          JSON.stringify(this.revenueTemplates)
        );
      });
    },
    reset() {
      this.revenueTemplates = JSON.parse(
        JSON.stringify(this.revenueTemplatesCopy)
      );
      this.templatesToDelete = [];
    },
    updateRevenueTemplates() {
      this.revenueTemplates.forEach((x) => {
        if (x.vatType) {
          x.vat = x.vatType.id;
        } else {
          x.vat = null;
        }
        if (x.serviceCode) {
          x.service_code = x.serviceCode.id;
        }
      });
      if (this.templatesToDelete.length > 0) {
        let promises = [];
        this.templatesToDelete.forEach((x) => {
          promises.push(
            this.apiRequest(
              `template/${this.companyId}/costs/templates/${x.id}/delete/`,
              "delete",
              true
            )
          );
        });
        Promise.all(promises).then(() => {
          this.apiRequest(
            `template/${this.companyId}/costs/templates/update/`,
            "patch",
            true,
            this.revenueTemplates
          ).then(() => {
            this.listTaskRevenueTemplates();
          });
        });
      } else {
        this.apiRequest(
          `template/${this.companyId}/costs/templates/update/`,
          "patch",
          true,
          this.revenueTemplates
        ).then(() => {
          this.listTaskRevenueTemplates();
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
      serviceObjects: "companyVariables/serviceObjects",
      taxTypes: "companyVariables/taxTypes",
      templateTypes: "companyVariables/templateTypes",
      units: "companyVariables/units",
    }),
    hasChanges() {
      return (
        !isEqual(this.revenueTemplates, this.revenueTemplatesCopy) ||
        this.templatesToDelete.length > 0
      );
    },
  },
};
</script>

<style scoped lang="scss">
.task-revenue-table {
  @apply gap-x-2;
  //                     type  name  price unit  tax  service delete
  grid-template-columns: 0.4fr 0.8fr 0.2fr 0.2fr 0.5fr 0.8fr 0.1fr;
}
</style>
